import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ecp-card-info',
  templateUrl: './card-info.component.html',
  styleUrls: ['./card-info.component.css']
})
export class CardInfoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
